commusoftCommon.service('smsTemplates',function () {
    this.templates = [];
    this.setTemplatesValue = function setTemplatesValue(smsTempValues) {
        this.templates = smsTempValues;
    }
    this.getSmsTemplates = function getSmsTemplates() {
        return this.templates;
    }
});